import type {RouteRecordRaw} from "vue-router";

/**
 * O signin fica FORA do AppLayout (o shell autenticado), por isso é exportado
 * em separado: o router monta as duas listas em lugares diferentes.
 */
export const usuarioRoutesPublicas: RouteRecordRaw[] = [
    {
        path: "/signin",
        name: "signin",
        meta: {authRequired: false},
        component: () => import("@/modules/usuario/pages/PageSignin.vue")
    },
];

export const usuarioRoutes: RouteRecordRaw[] = [
    {
        path: "/perfil",
        name: "perfil",
        meta: {authRequired: true},
        component: () => import("@/modules/usuario/pages/PagePerfil.vue")
    },
];
